<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <!-- Action buttons and record count -->
  <div class="action-row">
    <div class="action-left">
      <button class="resync-button"
              type="button"
              [disabled]="isResyncClicked"
              (click)="resync()">
        @if (loading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Re-sync
      </button>
    </div>
    @if (!noRecords) {
<div class="action-right">
      <span class="total-records">Total Records : {{sltKeySetupData.length}}</span>
    </div>
}
  </div>

  <!-- SMALL loader for data content -->
  @if (loading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  <!-- No records message -->
  @if (!loading && noRecords) {
<div>
    <span class="noRecords">No Records Found.</span>
  </div>
}

  <!-- Data table -->
  @if (!loading && sltKeySetupData.length > 0) {
<div>
    <div class="table-responsive">
      <table class="table table-hover table-bordered table-striped table-condensed custom-table">
        <thead>
          <tr>
            <th>SUBMISSION ID</th>
            <th>LEID</th>
            <th>LE KEY</th>
            <th>LE ME KEY</th>
            <th>ENTITY TYPE ID</th>
          </tr>
        </thead>
        <tbody>
          @for (obj of sltKeySetupData; track $index) {
<tr>
            <td>{{obj.SUBMISSION_ID}}</td>
            <td>{{obj.LEID}}</td>
            <td>{{obj.LE_KEY}}</td>
            <td>{{obj.LE_ME_KEY}}</td>
            <td>{{obj.ENTITY_TYPE_ID}}</td>
          </tr>
}
        </tbody>
      </table>
    </div>
  </div>
}
</div>
